/**
 * Shared lazy-video bootstrap.
 * Videos marked with data-fs-lazy-video (rendered with preload="none") only
 * start downloading and playing when they approach the viewport, pause when
 * they leave it, and fall back to visible controls when autoplay is blocked
 * (e.g. iOS Low Power Mode) or the user prefers reduced motion.
 * Used by: sections/image-with-text.liquid, sections/video-trio.liquid.
 * Safe to include from multiple sections - the observer is created once.
 */
(() => {
  const scan = () => {
    document
      .querySelectorAll('video[data-fs-lazy-video]')
      .forEach((video) => window.fsLazyVideoObserver.observe(video));
  };

  if (!window.fsLazyVideoObserver) {
    const showManualControls = (video) => {
      video.controls = true;
      if (video.preload === 'none') {
        video.preload = 'metadata';
        video.load();
      }
    };

    window.fsLazyVideoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              showManualControls(video);
            } else {
              video.play().catch(() => showManualControls(video));
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      },
      { rootMargin: '600px 0px' }
    );

    document.addEventListener('shopify:section:load', scan);
  }

  scan();
})();
